import getValuesAsString from './getValuesAsString';

/**
 * Return whether property values of an object match a given search string.
 *
 * @param search Search string
 * @param obj Object to match
 * @param keys Keys of properties to search
 */
const matchByProps = <T extends object>(
    search: string,
    obj: T,
    keys: Array<keyof T>
) => {
    if (!search) {
        return true;
    }
    const terms = search.split(' ')
        .map((w) => w.trim().toLowerCase())
        .filter((w) => w);
    const str = getValuesAsString(obj, keys);
    const matchN = terms.reduce((n, term) => n + +str.includes(term), 0);
    return matchN === terms.length;
};

export default matchByProps;
